import { useAppSelector } from "../../store/index.ts";
import { API_CASINO } from "../../api/casino";
import { useDispatch } from "react-redux";
import { setCampaignsById } from "../../store/promotionsSlice";
import { useReadLocalStorage } from "usehooks-ts";
import { ENUM_LCS_NAME } from "../../store/enums.js";
import StoreInfo from "../../controller/StoteInfo.js";
import { sleep } from "../../utils/utils.js";
import { useEffect, useRef } from "react";

export default function useCampaigns() {
  const dispatch = useDispatch();
  const campaigns = useAppSelector((state) => state.promotions.campaigns);
  const start_r = useReadLocalStorage(ENUM_LCS_NAME.startR) || "";

  const campaignsRef = useRef({});
  useEffect(() => {
    campaignsRef.current = campaigns;
  }, [campaigns]);

  // ждём пока кампания появится в сторе или закончится таймаут
  async function awaitCompany(id, tm) {
    return new Promise((rs) => {
      (async () => {
        setTimeout(() => {
          rs();
        }, tm);

        while (!campaignsRef.current[id]) {
          await sleep(100);
        }
        rs();
      })();
    });
  }

  const getCampaigns = async (id) => {
    try {
      // если запрос на инфу о кампании в процессе то ждём пока кампания появится в сторе или закончится таймаут
      if (StoreInfo.campaigns.inProgress.has(id)) {
        await awaitCompany(id, 5000);
        StoreInfo.campaigns.inProgress.delete(id);
      }
      // выдаём кампанию из стора
      const campaigns = campaignsRef.current;
      if (campaigns[id]) return campaigns[id];
      if (!id) return {};
      // добавляем в массив с кампаниями которые запрашиваются у сервера
      StoreInfo.campaigns.inProgress.add(id);
      const res = (await API_CASINO.getCampaignId({ campaignId: id, start_r })).data.info;
      dispatch(setCampaignsById({ data: res, id }));
      StoreInfo.campaigns.inProgress.delete(id);
      return res;
    } catch (e) {
      console.log(e);

      return {};
    }
  };

  return { getCampaigns };
}
